export enum BannerIconPosition {
  left = 'left',
  right = 'right',
}
